// extracted by mini-css-extract-plugin
module.exports = {"error":"EmailLoginForm_error__yO7tC","forgotPasswordContainer":"EmailLoginForm_forgotPasswordContainer__wbaxR"};